

















import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import LoginStaff from "@/views/authentication/LoginStaff.vue";
import Header from "@/views/layout/Header.vue";
import SideBar from "@/views/layout/SideBar.vue";
import HeaderLogin from "@/views/layout/HeaderLogin.vue";
import Sidebar from '@/views/layout/SideBar.vue';

@Component({
  components: {
    Header,
    SideBar,
    LoginStaff,
    HeaderLogin
  }
})
export default class Layout extends Vue {
  @Action("openStaffModal", { namespace: "RouteStore" })
  public openStaffModal: any;
  @Action("closeStaffModal", { namespace: "RouteStore" })
  public closeStaffModal: any;
  @Getter("staffModal", { namespace: "RouteStore" }) public onStaffModal: any;
  // @Getter('tokenTimeout', { namespace: 'AuthStore' }) public tokenTimeout: any;
  @Getter("title", { namespace: "Menu" })
  title!: (routeName: string) => string;

  titleNm: string = "";

  $refs!: {
    sidebar: Sidebar
  };

  public onSubmit(event: any) {
    if (event) {
      this.closeStaffModal();
      // this.$router.go(-1);
    }
  }

  private mounted() {
    this.updateSidebar();
    // this.openStaffModal();
    // console.log('staffModal', this.onStaffModal);
    // history.pushState('', 'Authen Staff', '/authenstaff');
  }

  updateSidebar() {
    this.$refs.sidebar.getNavigation().then(() => {
      this.setTitle();
      this.$forceUpdate();
    });
  }

  setTitle() {
    this.titleNm =  this.title(this.$route.name || "");
  }

  get pageTitle() {
    this.setTitle();
    return this.titleNm;

  }
}
